import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[type=date], input[type=datetime-local]'
})
export class AutoDatePickerDirective {
  constructor(private elementRef: ElementRef<HTMLInputElement>) {}

  @HostListener('focus')
  @HostListener('click')
  openPicker(): void {
    const input = this.elementRef.nativeElement as HTMLInputElement & { showPicker?: () => void };
    if (typeof input.showPicker === 'function') {
      try {
        input.showPicker();
      } catch {
        // Some browsers block repeated programmatic picker opens during the same interaction.
      }
    }
  }
}
